"use client";
import { useState } from "react";
import Image from "next/image";
import Section from "@/components/Section";
import ProductPage from "@/components/ProductPage";

import ImageHero from "./referenzen.jpg";

import Tamaris from "./tamaris.webp";
import SOliver from "./s.Oliver.webp";
import Mariage from "./mariage.webp";
import RomeoJulia from "./romeojulia.webp";
import Felissimo from "./Felicissimo.webp";
import Testoni from "./testoni.webp";
import JrbHeimwerker from "./jrbHeimwerker.webp";
import Grandprix from "./grandprix.webp";
import Cestmoi from "./cestmoi.webp";
import ItaloJeans from "./italojeans.webp";
import Highstyle from "./highstyle.webp";
import ImmagineModa from "./immaginemoda.webp";
import Poettler from "./poettler.webp";
import SajuBrautservice from "./sajuBrautservice.webp";
import ColoursAndSons from "./coloursandsons.webp";
import LuckyDeLuca from "./luckydeluca.webp";
import SaltySkin from "./saltyskin.webp";
import Ace from "./ace.webp";
import Amalz from "./amalz.webp";
import SixOSeven from "./Six-O-Seven.webp";
import Fashionpoint from "./fashionpoint.webp";
import MarcoVenezia from "./marcovenezia.webp";
import AgaGottschalk from "./agagottschalk.webp";
import VincenzoAlocca from "./VincenzoAlocca.webp";
import Ahmaddy from "./ahmaddy.webp";
import Fuchs from "./fuchs.webp";
import Sina from "./sina.webp";
import Kamuflage from "./kamuflage.webp";
import Goodstuff from "./goodstuff.png";
import Hitzegrad from "./hitzegrad.jpeg";
import Alpensuende from "./alpensünde.webp";
import AccessoiresAndMore from "./accessoires-and-more.webp";
import Almsach from "./almsach.jpeg";
import PhilomenaChrist from "./PhilomenaChrist.webp";
import Bergweiss from "./bergweiss.png";
import FemininPlus from "./femininPlus.webp";
import Schuhshop24 from "./schuhshop-24.png";
import JoyEdition from "./joyEdition.png";
import TrachtenWolf from "./trachtenWolf.webp";
import DtDesign from "./dtdesign.png";
import EmilyAngel from "./Emily&Angel.png";
import Blossom from "./blossom.png";
import Chapati from "./chapati.png";
import Balke from "./balke.png";
import Modeln from "./modeIn.jpg";
import MikaMode from "./mikaMode.jpg";
import ModaSende from "./modasende.png";
import CRH from "./crh.jpg";
import EURA from "./eura.jpg";
import LogoMesch from "./logomesch.svg";
import Kachouri from "./kachouri.svg";
import Luren from "./luren.svg";

type Kategorie =
  | "Einzelhandel"
  | "Großhandel"
  | "App-Entwicklung"
  | "Web-Entwicklung";

interface Referenz {
  name: string;
  image: any;
  kategorien: Kategorie[];
  href?: string;
}

const referenzen: Referenz[] = [
  { name: "Tamaris", image: Tamaris, kategorien: ["Einzelhandel"]},
  { name: "s.Oliver", image: SOliver, kategorien: ["Einzelhandel"]},
  { name: "Mariage", image: Mariage, kategorien: ["Einzelhandel"]},
  { name: "Romeo & Julia", image: RomeoJulia, kategorien: ["Einzelhandel"] },
  { name: "Felicissimo", image: Felissimo, kategorien: ["Web-Entwicklung"], href: "https://www.felicissimo.de/" },
  { name: "Testoni", image: Testoni, kategorien: ["Web-Entwicklung"] },
  { name: "JRB Der Heimwerker", image: JrbHeimwerker, kategorien: ["Einzelhandel"] },
  { name: "Grandprix-Originals", image: Grandprix, kategorien: ["Einzelhandel"] },
  { name: "boutique c'est moi", image: Cestmoi, kategorien: ["Einzelhandel"] },
  { name: "Italo Jeans", image: ItaloJeans, kategorien: ["Einzelhandel"] },
  { name: "Highstyle", image: Highstyle, kategorien: ["Einzelhandel"] },
  { name: "Immagine Moda", image: ImmagineModa, kategorien: ["Einzelhandel"] },
  { name: "Pöttler Alois Schuhservice", image: Poettler, kategorien: ["Einzelhandel"] },
  { name: "Brautservice Saju", image: SajuBrautservice, kategorien: ["Einzelhandel"] },
  { name: "Colours & Sons", image: ColoursAndSons, kategorien: ["Großhandel"] },
  { name: "Lucky De Luca", image: LuckyDeLuca, kategorien: ["Großhandel"] },
  { name: "Spinach Mafia & Salty Skin", image: SaltySkin, kategorien: ["Web-Entwicklung"] },
  { name: "Accessoires Center Eschborn", image: Ace, kategorien: ["Einzelhandel"] },
  { name: "A.Malz GmbH", image: Amalz, kategorien: ["Großhandel"], href: "https://malz-tuchfabrik-b2b.de/" },
  { name: "six-o-seven", image: SixOSeven, kategorien: ["Großhandel"] },
  { name: "Fashion-Point", image: Fashionpoint, kategorien: ["Großhandel"] },
  { name: "Marco Venezia", image: MarcoVenezia, kategorien: ["Großhandel"] },
  { name: "Gottschalk AGA Textilvertrieb", image: AgaGottschalk, kategorien: ["Einzelhandel"], href: "http://www.aga-textil.de/" },
  { name: "Vincenzo Alocca", image: VincenzoAlocca, kategorien: ["Einzelhandel"] },
  { name: "ahmaddy", image: Ahmaddy, kategorien: ["Großhandel"] },
  { name: "Fuchs", image: Fuchs, kategorien: ["Web-Entwicklung"], href: "https://www.fuchs-moden.com/" },
  { name: "Sina", image: Sina, kategorien: ["Einzelhandel"] },
  { name: "Kamuflage", image: Kamuflage, kategorien: ["Einzelhandel"] },
  { name: "Goodstuff Fashion", image: Goodstuff, kategorien: ["Einzelhandel"] },
  { name: "Orthopädie SchuhtechnikHitzegrad", image: Hitzegrad, kategorien: ["Einzelhandel"] },
  { name: "Alpensünde", image: Alpensuende, kategorien: ["Einzelhandel"] },
  { name: "Accessoires & More", image: AccessoiresAndMore, kategorien: ["Web-Entwicklung"], href: "https://www.accessoires-and-more.de/" },
  { name: "Almsach", image: Almsach, kategorien: ["Web-Entwicklung"], href: "https://almsach.de/" },
  { name: "Philomena Christ", image: PhilomenaChrist, kategorien: ["Einzelhandel"] },
  { name: "Bergweiss", image: Bergweiss, kategorien: ["Web-Entwicklung"], href: "https://bergweiss-trachten.de/" },
  { name: "Feminin Plus", image: FemininPlus, kategorien: ["Web-Entwicklung"], href: "https://www.femininplus.de/" },
  { name: "Schuhshop 24", image: Schuhshop24, kategorien: ["Web-Entwicklung"], href: "https://schuhshop-24.de/" },
  { name: "Joy Edition", image: JoyEdition, kategorien: ["Web-Entwicklung"], href: "https://joyedition-shop.de/" },
  { name: "Trachten Wolf", image: TrachtenWolf, kategorien: ["Einzelhandel"], href: "https://www.trachtenwolf.de/" },
  { name: "D&T Design", image: DtDesign, kategorien: ["App-Entwicklung"], href: "https://start.d-t-design.de/" },
  { name: "Emily & Angel", image: EmilyAngel, kategorien: ["Web-Entwicklung"], href: "https://emilyandangel.de/" },
  { name: "Blossom Clothes&Accessoires", image: Blossom, kategorien: ["Einzelhandel"] },
  { name: "Chapati Berlin", image: Chapati, kategorien: ["Web-Entwicklung"], href: "https://chapati.de/" },
  { name: "kai B. Hat and Cap Design", image: Balke, kategorien: ["Einzelhandel"] },
  { name: "Mode ln", image: Modeln, kategorien: ["Web-Entwicklung"], href: "https://modein.de/" },
  { name: "Mika Mode", image: MikaMode, kategorien: ["Einzelhandel"] },
  { name: "Modasen.de", image: ModaSende, kategorien: ["Einzelhandel"], href: "https://modasen.de/" },
  { name: "Franz Gustav", image: CRH, kategorien: ["Einzelhandel"], href: "https://franzgustav.com/" },
  { name: "EURA", image: EURA, kategorien: ["Einzelhandel"], href: "https://www.eura-fashion.de/" },
  { name: "Mesch Sportswear", image: LogoMesch, kategorien: ["Einzelhandel"], href: "https://mesch-sportswear.de/Explore/Unsere-Geschichte/" },
  { name: "Kachouri Getränkeservice", image: Kachouri, kategorien: ["Einzelhandel"], href: "https://www.kachouri-getraenke-service.de/" },
  { name: "Lu Ren", image: Luren, kategorien: ["Einzelhandel"], href: "https://lu-ren.com/" },
];

type Filter = "Alle" | Kategorie;
const filters: Filter[] = [
  "Alle",
  "Einzelhandel",
  "Großhandel",
  "App-Entwicklung",
  "Web-Entwicklung",
];

const cardClass =
  "flex items-center justify-center p-5 rounded-2xl border border-slate-200 bg-white hover:shadow-md hover:-translate-y-1 transition-all min-h-30";

function ReferenzenGrid() {
  const [aktiv, setAktiv] = useState<Filter>("Alle");

  const gefiltert =
    aktiv === "Alle"
      ? referenzen
      : referenzen.filter((r) => r.kategorien.includes(aktiv as Kategorie));

  return (
    <Section className="bg-white py-6 md:py-10 mt-10">
      {/* Filter-Buttons */}
      <div className="flex flex-wrap justify-center gap-3 mb-10">
        {filters.map((f) => (
          <button
            key={f}
            onClick={() => setAktiv(f)}
            className={`px-5 py-2 rounded-full border text-sm font-medium transition-all ${
              aktiv === f
                ? "bg-(--brand-700) text-white border-(--brand-700)"
                : "bg-white text-slate-700 border-slate-300 hover:border-slate-400"
            }`}
          >
            {f}
          </button>
        ))}
      </div>

      {/* Karten-Grid */}
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
        {gefiltert.map((ref, i) =>
          ref.href ? (
            <a
              key={i}
              href={ref.href}
              target="_blank"
              rel="noopener noreferrer"
              className={`${cardClass} cursor-pointer`}
            >
              <Image
                src={ref.image}
                alt={ref.name}
                className="max-h-20 w-auto object-contain"
                style={{ maxWidth: "100%" }}
              />
            </a>
          ) : (
            <div key={i} className={cardClass}>
              <Image
                src={ref.image}
                alt={ref.name}
                className="max-h-20 w-auto object-contain"
                style={{ maxWidth: "100%" }}
              />
            </div>
          )
        )}
      </div>
    </Section>
  );
}

export { referenzen };
export default function Referenzen() {
  return (
    <>
      <ProductPage
        productName="Referenzen – SDI Group"
        hero={{
          title: "Unsere Referenzen",
          subtitle:
            "Erfolgreiche Projekte, zufriedene Kunden und nachhaltige Lösungen – hier finden Sie eine Auswahl unserer Referenzen aus verschiedenen Branchen.",
          buttonLeft: {
            title: "Kontakt aufnehmen",
            href: "/kontakt",
          },
          buttonRight: {
            title: "Firmenprofil",
            href: "/ueber-uns",
          },
          image: ImageHero,
          imageAlt: "Unsere Referenzen",
          imageFit: "contain",
        }}
        highlight={{
          image: ImageHero,
          bullets: [],
        }}
        beforeVideo={<ReferenzenGrid />}
        faqs={[
          {
            q: "Aus welchen Branchen stammen Ihre Referenzkunden?",
            a: "Unsere Kunden kommen aus dem Textil- und Schuheinzelhandel, dem Großhandel, Second-Hand, Getränkemärkten sowie dem Friseur- und Kosmetikbereich – quer durch den stationären Handel.",
          },
          {
            q: "Wie lange arbeiten Ihre Kunden im Durchschnitt mit Ihnen zusammen?",
            a: "Viele unserer Kunden sind seit Jahren oder sogar Jahrzehnten Partner der SDI Group – das spricht für die Stabilität und Qualität unserer Lösungen.",
          },
          {
            q: "Bieten Sie auch individuelle Lösungen für besondere Anforderungen an?",
            a: "Ja, wir entwickeln maßgeschneiderte Software und Schnittstellen, die exakt auf die Prozesse und Bedürfnisse unserer Kunden zugeschnitten sind.",
          },
          {
            q: "Wo sind Ihre Referenzkunden ansässig?",
            a: "Unsere Kunden sind vorwiegend im deutschsprachigen Raum tätig – Deutschland, Österreich und der Schweiz – von kleinen Fachgeschäften bis hin zu mittelständischen Unternehmen.",
          },
          {
            q: "Wie kann ich eine Produktdemo oder Beratung anfragen?",
            a: "Nehmen Sie einfach über unser Kontaktformular oder telefonisch Kontakt auf – wir zeigen Ihnen gerne in einer persönlichen Demo, wie unsere Lösungen funktionieren.",
          },
        ]}
        features={[]}
      />
    </>
  );
}